const rxNumberValidation = value => {
  if (!value) {
    return { rxNumber: '*Required' };
  } else if (!/^[0-9-]{1,20}$/.test(value)) {
    return { rxNumber: '*Invalid Rx Number' };
  }
  return {};
};

export default rxNumberValidation;



// WEBPACK FOOTER //
// ./src/components/Forms/Validations/rxNumberValidation.js